'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _urls = require('../../utils/urls');

var _components = require('../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CuratorInfo = require('./CuratorInfo.scss');

var _CuratorInfo2 = _interopRequireDefault(_CuratorInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CuratorInfo = function (_Component) {
    (0, _inherits3.default)(CuratorInfo, _Component);

    function CuratorInfo() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CuratorInfo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CuratorInfo.__proto__ || (0, _getPrototypeOf2.default)(CuratorInfo)).call.apply(_ref, [this].concat(args))), _this), _this.mapCurators = function (curator) {
            var curatorImgUrl = _this.props.curatorImgUrl;

            return (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.curator
            }, curator.id, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: 'img-circle ' + _CuratorInfo2.default.image,
                src: (0, _urls.getCuratorImageUrl)(curatorImgUrl, curator.id, curator.imageFileName)
            }), (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.details
            }, void 0, (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.name
            }, void 0, curator.name), (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.title
            }, void 0, curator.expertise)), (0, _jsx3.default)('div', {
                style: { clear: 'both' }
            }));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CuratorInfo, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'curatorImgUrl', 'curators']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                curators = _props.curators,
                className = _props.className;


            var classes = (0, _classnames2.default)(_CuratorInfo2.default['curator-info'], className);

            return curators.length ? (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('span', {
                className: _CuratorInfo2.default.label
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_curated_by'
            }), ':'), curators.map(this.mapCurators)) : (0, _jsx3.default)('div', {});
        }
    }]);
    return CuratorInfo;
}(_react.Component);

exports.default = CuratorInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CuratorInfo/CuratorInfo.js
// module id = CyO3
// module chunks = 46